import { Link } from "wouter";
import {
  TERMS_SECTIONS,
  PRIVACY_SECTIONS,
  LEGAL_LAST_UPDATED,
  PRIVACY_LAST_UPDATED,
  type LegalSection,
} from "../content/legal";
import { BrandWordmark } from "../components/BrandWordmark";

function LegalPage({
  title,
  lastUpdated,
  sections,
  otherHref,
  otherLabel,
}: {
  title: string;
  lastUpdated: string;
  sections: LegalSection[];
  otherHref: string;
  otherLabel: string;
}) {
  return (
    <main className="min-h-screen bg-white px-6 py-12 text-neutral-900">
      <div className="mx-auto max-w-2xl">
        <Link href="/" className="inline-flex items-center gap-2">
          <BrandWordmark className="h-6" />
        </Link>
        <h1 className="mt-8 font-display text-3xl font-bold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-neutral-600">Last updated {lastUpdated}.</p>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-neutral-700">
          {sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-semibold text-neutral-900">{section.heading}</h2>
              {section.body.map((para) => (
                <p key={para} className="mt-2">
                  {para}
                </p>
              ))}
            </section>
          ))}
        </div>
        <p className="mt-10 border-t border-neutral-100 pt-6 text-sm">
          <Link href={otherHref} className="font-medium text-sky-700 hover:underline">
            {otherLabel}
          </Link>
        </p>
      </div>
    </main>
  );
}

export function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      lastUpdated={LEGAL_LAST_UPDATED}
      sections={TERMS_SECTIONS}
      otherHref="/privacy"
      otherLabel="Read the Privacy Policy"
    />
  );
}

export function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated={PRIVACY_LAST_UPDATED}
      sections={PRIVACY_SECTIONS}
      otherHref="/terms"
      otherLabel="Read the Terms of Use"
    />
  );
}
